import { createReducer } from '@reduxjs/toolkit'
import { CURRENCY_LIST } from 'config/constants'
import * as actions from './actions'

export interface CurrencyAppState {
  currencyApp: string
}

const initialState: CurrencyAppState = {
  currencyApp: CURRENCY_LIST?.[0]?.flag,
}

export default createReducer<CurrencyAppState>(initialState, (builder) =>
  builder.addCase(actions.setCurrency, (state, { payload }) => {
    state.currencyApp = payload
  }),
)
